import GameUtil from "../utility/game_util";
import ModelData, { IUserData } from '../pacakge/public/model_data';
import AppData from "../pacakge/public/const/app_data";
import TextureManager from './texture_manager';
import EventManager from '../manager/event_manager'
import TimeManager from "./time_manager";
import LogManager from "./log_manager";

export interface IUserCurrencyData {
    chip : number,
    daibi: number,
    gameTableChip : number
    freez?:number;

    chipClub ?: number, //俱乐部Chip
    chipClubSafebox ?: number  //俱乐部保险箱
}


//用户类
export default class UserDataManager {
    static _userDatas = {}
    static _defaultAvatarSprites = {}
    static _selfCurrencyData : IUserCurrencyData = {chip : 0, daibi: 0, gameTableChip : 0, freez : 0, chipClub : 0, chipClubSafebox : 0}
    static _lastGetCurrencyDataTime 
    protected static m_refresh_money_schedule_id: number = 0


    //获取通用数据，必须要下载完头像数据才会返回
    static getData(uid : Number, callback : (data : IUserData)  => void, useNewData?: boolean) {
        if(!useNewData){
            let userdata : IUserData = UserDataManager._userDatas[uid.toString()]
            if (userdata && ((userdata.getAvatarSuccess && userdata.avatarSprite) || (userdata.avatar && userdata.avatar.length < 3)) && callback) {
                callback(userdata)
                return
            }
            let isSelf = ModelData.instance.roleData && uid == ModelData.instance.roleData.id
            //新得数据获取 就缺少服务器头像
            if (userdata && (!userdata.getAvatarSuccess || userdata.avatarSprite == null) && userdata.avatar && userdata.avatar.length > 4){
                let tmpOnFinish = function(spriteFrame){
                    UserDataManager._userDatas[uid.toString()].avatarSprite = spriteFrame
                    callback(userdata)
                }
                //获取头像
                let result = isSelf && TextureManager.instance.tryGetSpriteFromDisk(userdata.avatar, tmpOnFinish)
                if(result){                    
                    return
                }
                let hasLoadFromRemote = false
                TimeManager.instance.scheduleOnce(()=>{
                    if(!hasLoadFromRemote){
                        let url = (userdata.male ? "201.png" : "101.png")
                        UserDataManager.getAvatarSprite(url, (sprite) => {
                            userdata.avatarSprite = sprite                   
                            callback && callback(userdata)
                        }, isSelf)
                    }
                }, 0.2)
                
                
                TextureManager.instance.getSprite(userdata.avatar, function(spriteFrame: cc.SpriteFrame, blob: Uint8Array){
                    hasLoadFromRemote = true
                    isSelf && blob && TextureManager.instance.saveAvatarSpriteToLocalDisk(userdata.avatar, blob)
                    tmpOnFinish(spriteFrame)
                })
                return
            }
        }        
        UserDataManager._getUserData(uid, callback)
    }

    //从后台获取数据
    static getDataFromServer(uid : Number, callback : (data : IUserData)  => void) {
        UserDataManager._getUserData(uid, callback)
    }

    static getOtherCurrencyData(uid : Number, callback : (currencyData : IUserCurrencyData)  => void){
        let requestData: IHttpRequestData = {
            baseUrl: "account/otherInfo?",
            params: {
                otherUserId : uid,
                accountTypeList : [6]
            }
        }
        GameUtil.apiHttpGet(requestData, (res) => {
            let currencyData : IUserCurrencyData = {
                chip:0,
                daibi:0,
                gameTableChip:0,
                freez:0,
            };
            res.data.accountList.forEach(element => {
                element.balance = Number(element.balance)
                if(element.accountType == 6) {
                    currencyData.chip = element.balance
                    currencyData.freez = Number(element.freez)
                    let userdata : IUserData = UserDataManager._userDatas[uid.toString()]
                    if (userdata) {
                        currencyData.gameTableChip = userdata.gameTableGold
                    }
                } else if(element.accountType == 7) {

                }
                else if (element.accountType == 100){
                    currencyData.daibi = element.balance
                }
            });

            callback && callback(currencyData)        
        })
    }

    //获取货币数据
    static getCurrencyData(uid : Number, callback : (currencyData : IUserCurrencyData)  => void, useNewData ?:boolean, immediatelyObtail?:boolean ) {
   
        let self = UserDataManager         
        let hasCallCallback = false
        if (!useNewData) {
            if (callback) {
                callback(UserDataManager._selfCurrencyData)
                hasCallCallback = true
            }
        }

        if (Date.now() - self._lastGetCurrencyDataTime < 1000 && !immediatelyObtail) { //如果是小于1秒的就不再重复获取货币数据
            return
        }
        
        if(ModelData.instance.roleData.id.toString() == uid.toString()){
            TimeManager.instance.cancelSchedule(self.m_refresh_money_schedule_id)
            self.m_refresh_money_schedule_id = TimeManager.instance.doScheduleOnce(function(){
                self.getCurrencyData(uid, null, true)
            }, 180)
        }
        if (AppData.inTable && !immediatelyObtail) {
            return
        }
        self._lastGetCurrencyDataTime = Date.now()
        
        let requestData: IHttpRequestData = {
            baseUrl: "account/info?",
            params: {
                gameUserId : uid,
                accountTypeList : "6,100"  //"6,100,200,201"
            }
        }

        if (ModelData.instance.clubId > 0) {
            requestData.params["accountTypeList"] = "200,201"
            requestData.params["userClubId"] = ModelData.instance.clubId
        }

        GameUtil.apiHttpGet(requestData, (res) => {
            let currencyDataUpdate = false
            res.data.accountList.forEach(element => {
                element.balance = Number(element.balance)
                element.freez = Number(element.freez)
                if (element.accountType == 5 && UserDataManager._selfCurrencyData.chip != element.balance) {
                    UserDataManager._selfCurrencyData.chip = element.balance
                    currencyDataUpdate = true
                } else if(element.accountType == 6 && (UserDataManager._selfCurrencyData.chip != element.balance || UserDataManager._selfCurrencyData.freez != element.freez)) {
                    UserDataManager._selfCurrencyData.chip = element.balance
                    UserDataManager._selfCurrencyData.freez = element.freez;
                    currencyDataUpdate = true
                } 
                else if (element.accountType == 100 && UserDataManager._selfCurrencyData.daibi != element.balance){
                    UserDataManager._selfCurrencyData.daibi = element.balance
                    currencyDataUpdate = true
                } else if (element.accountType == 200 && UserDataManager._selfCurrencyData.chipClub != element.balance){
                    UserDataManager._selfCurrencyData.chipClub = element.balance
                    currencyDataUpdate = true
                } else if (element.accountType == 201 && UserDataManager._selfCurrencyData.chipClubSafebox != element.balance){
                    UserDataManager._selfCurrencyData.chipClubSafebox = element.balance
                    currencyDataUpdate = true
                }
  
            });
            if (!hasCallCallback) {
                callback && callback(UserDataManager._selfCurrencyData)                    
            }
            if(currencyDataUpdate){
                EventManager.instance.dispatch("refresh_user_money", UserDataManager._selfCurrencyData)
            }
        })
    }



    static balanceChangeMessage(balance:number, balancetype ?: number, balanceIsAdd ?: boolean){
        if (!balancetype) {
            //balancetype = 6
            balancetype = ModelData.instance.tableCommonData.isClubTable? 200 : 6;
        }
        
        let isUpdate = false
        if (balancetype == 6 && UserDataManager._selfCurrencyData.chip != balance) {
            UserDataManager._selfCurrencyData.chip = balanceIsAdd ? UserDataManager._selfCurrencyData.chip + balance : balance
            isUpdate = true
        }
        else if (balancetype == 100 && UserDataManager._selfCurrencyData.daibi != balance){
            UserDataManager._selfCurrencyData.daibi = balanceIsAdd ? UserDataManager._selfCurrencyData.daibi + balance : balance
            isUpdate = true
        } else if (balancetype == 200 && UserDataManager._selfCurrencyData.chipClub != balance){
            UserDataManager._selfCurrencyData.chipClub = balanceIsAdd ? UserDataManager._selfCurrencyData.chipClub + balance : balance
            isUpdate = true
        } else if (balancetype == 201 && UserDataManager._selfCurrencyData.chipClubSafebox != balance){
            UserDataManager._selfCurrencyData.chipClubSafebox = balanceIsAdd ? UserDataManager._selfCurrencyData.chipClubSafebox + balance : balance
            isUpdate = true
        }
        if (isUpdate) {
            EventManager.instance.dispatch("refresh_user_money", UserDataManager._selfCurrencyData)
        }
    }

    private static _getUserData(uid : Number, callback : (data : IUserData, error : string)  => void) {
        if (uid == 0) {
            return
        }
        let requestData: IHttpRequestData 
        if (ModelData.instance.roleData.id && uid != ModelData.instance.roleData.id) {
            requestData = {
                baseUrl: "user/otherInfo?",
                params: {
                    otherUserId : uid,
                }
            }
        } else {
            requestData = {
                baseUrl: "user/info?",
                params: {}
            }
        }
        let isSelf = ModelData.instance.roleData && uid == ModelData.instance.roleData.id
        GameUtil.apiHttpGet(requestData, function (res) {
            if(res.data == undefined){
                callback && callback(null,null)
                return
            }
            let lastUserData = UserDataManager._userDatas[uid.toString()]
            let userData = UserDataManager._setUserCacheData(uid, res.data)
            UserDataManager._userDatas[uid.toString()] = userData
            ModelData.instance.refreshRoleData(res.data)
            if (!userData.avatar || userData.avatar.indexOf("http") == -1) {
                let url = userData.avatar ? userData.avatar : (userData.male ? "201.png" : "101.png")
                UserDataManager.getAvatarSprite(url, (sprite) => {
                    userData.avatarSprite = sprite
                    userData.getAvatarSuccess = true
                    if (callback) {
                        callback(userData, null)
                    }
                    if (uid == ModelData.instance.roleData.id) {
                        EventManager.instance.dispatch("refresh_user_data", userData)
                    }
                }, isSelf)
            } else if (userData.avatar.indexOf("http") >= 0){
                let hasLoadFromRemote = false
                TimeManager.instance.scheduleOnce(()=>{
                    if(!hasLoadFromRemote){
                        let url = (userData.male ? "201.png" : "101.png")
                        UserDataManager.getAvatarSprite(url, (sprite) => {
                            userData.avatarSprite = sprite                   
                            if (callback) {
                                callback(userData, null)
                            }
                        }, isSelf)
                    }
                }, 0.2)
                
                UserDataManager.getAvatarSprite(userData.avatar, (sprite) => {
                    hasLoadFromRemote = true
                    userData.avatarSprite = sprite
                    userData.getAvatarSuccess = true
                    if (callback) {
                        callback(userData, null)
                    }
                    if (uid == ModelData.instance.roleData.id) {
                        if(lastUserData && lastUserData.avatar.indexOf("http") >= 0 && lastUserData.avatar != userData.avatar){
                            TextureManager.instance.deleteAvatarSpriteFromLocalDisk(lastUserData.avatar)                                
                        }
                        EventManager.instance.dispatch("refresh_user_data", userData)
                    }
                }, isSelf)

            } 
            if (uid == ModelData.instance.roleData.id) {
                LogManager.instance.needUploadLogFile(userData.clientLogInfo)
            }
        }, (retData) => {

        })
    }

    static getAvatarSprite(avatarImageUrl : string, callback: (spriteFrame: cc.SpriteFrame) => void, isSelf ?: boolean,gender?: number) {
        if (!avatarImageUrl || avatarImageUrl.indexOf("http") == -1) {
            let avatarSprite = ModelData.instance.getPlayerIconByName(avatarImageUrl)
            callback(avatarSprite)
        } else if (avatarImageUrl.indexOf("http") >= 0){
            let tmpOnFinish = function(spriteFrame){
                hasLoadFromRemote = true;
                callback(spriteFrame)
            }

            let hasLoadFromRemote = false
            if (gender) {            
                TimeManager.instance.scheduleOnce(()=>{
                    if(!hasLoadFromRemote){
                        let avatarSprite = ModelData.instance.getPlayerIconByName(gender == 1 ? "201.png" : "101.png")
                        callback(avatarSprite)
                    }
                },0.2);
            } 

            let result = isSelf && TextureManager.instance.tryGetSpriteFromDisk(avatarImageUrl, tmpOnFinish)
            if(!result){  
                TextureManager.instance.getSprite(avatarImageUrl, (sprite, blob) => {   
                    isSelf && blob && TextureManager.instance.saveAvatarSpriteToLocalDisk(avatarImageUrl, blob)                     
                    tmpOnFinish(sprite)
                })
            }
        } 
    }

    static _setUserCacheData(uid : Number, data : any) : IUserData {
        let userdata : IUserData = UserDataManager._userDatas[uid.toString()];
        if (!userdata) {
            userdata = {}
            userdata.gameTableGold = 0
        }
        userdata.id = data.gameUserId
        if(data.gameUserId < 10000)
        {
            userdata.idShow = "10000" + userdata.id
        } else {
            userdata.idShow = userdata.id.toString()
        }
        userdata.name = data.nickname.trim()
        userdata.gold = data.gold
        userdata.avatar = data.headImg
        userdata.gender = data.gender
        userdata.male = data.gender == 1
        userdata.inviteCode = data.inviteCode
        userdata.parentId = data.parentId
        userdata.mobile = data.mobile
        userdata.matchingChannelId = data.independent ? data.channelId : undefined
        userdata.haveCofferPassport = data.haveCofferPassport;
        userdata.clientLogInfo = data.clientLogInfo
        userdata.expCurrent = data.expCurrent
        userdata.expNext = data.expNext
        userdata.userLevel = data.userLevel
        userdata.friend = data.friend
        userdata.passportThridType = data.passportThridType || 0;
        userdata.vipConfigList = data.vipConfigList;
        userdata.plizedCardIcon = data.plizedCardIcon
        userdata.plizedHeadFrame = data.plizedHeadFrame
        userdata.plizedHeadImg = data.plizedHeadImg
        return userdata
    }


    //一般用于游戏服主动下发
    static setUserJsonData(userStr:string){
        if (userStr == null || userStr == ""){
            return
        }
        let user = JSON.parse(userStr)
        if (user.err != undefined) {//错误的str
            return;
        }

        let isOld = user.user_id == undefined;
        let userId = isOld? user.gameUserId: user.user_id
        let userdata : IUserData = UserDataManager._userDatas[userId] || {}
        userdata.id =userId
        userdata.name =isOld? user.nickname.trim(): user.nick_name.trim()
        userdata.avatar =isOld? user.headImg: user.img
        userdata.avatarSprite = null
        userdata.gender = user.gender
        userdata.vipConfigList = user.vipConfigList || [];
        userdata.gameTableGold = userdata.gameTableGold ? userdata.gameTableGold : 0
        userdata.plizedCardIcon = user.plizedCardIcon
        userdata.plizedHeadFrame = user.plizedHeadFrame
        
        UserDataManager._userDatas[userId] = userdata
        if (!userdata.avatar || userdata.avatar.indexOf("http") == -1) {
            let url = userdata.avatar ? userdata.avatar : (userdata.male ? "201.png" : "101.png")
            userdata.avatarSprite = ModelData.instance.getPlayerIconByName(url)
            userdata.getAvatarSuccess = true
        } 
        else 
        {
            TextureManager.instance.getSprite(userdata.avatar, (sprite) => {
                userdata.avatarSprite = sprite
                userdata.getAvatarSuccess = true
            })
        }
    }

    static setUserGameTableCurrency(uid : number, curGameGold : number) {
        let userdata : IUserData = UserDataManager._userDatas[uid.toString()] || {}
        userdata.gameTableGold = curGameGold
        UserDataManager._userDatas[uid.toString()] = userdata
        if (uid == ModelData.instance.roleData.id) {
            UserDataManager._selfCurrencyData.gameTableChip = curGameGold;
        }
    }

    static clearGetCurrencyDataState() {
        UserDataManager._lastGetCurrencyDataTime = 0
    }

    static clearCurrencyData(){
        UserDataManager._selfCurrencyData.chip = 0        
        UserDataManager._selfCurrencyData.daibi = 0
        UserDataManager._selfCurrencyData.chipClub = 0
        UserDataManager._selfCurrencyData.chipClubSafebox = 0
        UserDataManager._selfCurrencyData.freez = 0
    }

    static clearPlayerDataById(uid){
        if (uid) {
            UserDataManager._userDatas[uid.toString()] = null
        }
    }

    static reset(){
        UserDataManager.clearCurrencyData()
        UserDataManager.clearGetCurrencyDataState()
    }
}